





















import { Vue, Component, Prop } from 'vue-property-decorator';

import PaymentTypes from './PaymentTypes/PaymentTypes.vue';
import PaymentActions from './PaymentActions/PaymentActions.vue';

import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';

import { ECardStep } from '@/helpers/enums';

@Component({
  components: {
    PaymentTypes,
    PaymentActions,
    ScreenSizeVisibility,
  },
})
export default class PaymentMethods extends Vue {
  public $refs!: {
    paymentTypes: PaymentTypes,
  };

  @Prop()
  private readonly isUpsell!: boolean;

  @Prop()
  private readonly isAddressRequired!: boolean;

  @Prop()
  private readonly validateDeliveryAddress!: Function;

  public updateUpsell(payload: any) {
    this.$emit('updateUpsell', payload);
  }

  public dispatchStatus (status: string) {
    this.$emit(status);
  }

  private validatePaymentType (options: { type: 'creditCard' | 'bankSlip' | 'wireTransfer', step: ECardStep }) {
    return this.$refs.paymentTypes.validatePaymentType(options);
  }
}
